import React from 'react';
import { prop, propOr, pathOr } from 'ramda';
import cx from 'classnames';

import { TextLine } from './lineTemplates';
import CustomIcon from 'components/common/CustomIcon';

const getTextProp = propOr('', 'text');

export const LinkTextLine = ({ className, handler, value, icon }) => {
    return (
        <a className={className} onClick={handler}>
            { icon ? <CustomIcon type={icon} /> : <TextLine value={value}/>}
        </a>
    );
};

export const DocumentLink = ({ handlers: { openModalDocument }, value: document }) => {
    const value = prop('name', document) || pathOr('', ['text', 'title'], document);
    const handler = () => openModalDocument(document);

    return (
        <LinkTextLine handler={handler} value={value}/>
    );
};

export const EventLink = ({ handlers: { openModalEvent }, value: event }) => {
    const value = pathOr(getTextProp(event), ['text', 'title'], event);
    const handler = () => openModalEvent({
        ...event,
        value
    });

    return (
        <LinkTextLine handler={handler} value={value} className={cx({'closeable': event.closeable})}/>
    );
};

export const ProjectLink = ({ value: project, handlers: { openModalProject } }) => {
    const value = getTextProp(project);

    return (
        <a onClick={() => openModalProject(project)}>
            <TextLine value={value}/>
        </a>
    );
};

export const PersonLink = ({ handlers: { openModalPerson }, value: person }) => {
    const value = getTextProp(person);
    const handler = () => openModalPerson({ ...person, value });

    return (
        <LinkTextLine handler={handler} value={value}/>
    );
};

export const CompanyLink = ({ handlers: { openModalCompany }, value: company }) => {
    const text = pathOr(getTextProp(company), ['title'], company);
    const handler = () => openModalCompany({ ...company, text });

    return (
        <LinkTextLine handler={handler} value={text}/>
    );
};
